import { Link } from "@tanstack/react-router";

interface SignInLegalNoteProps {
  /** Light text for the dark gradient call-to-action. */
  onDark?: boolean;
  className?: string;
}

export default function SignInLegalNote({
  onDark = false,
  className = "",
}: SignInLegalNoteProps) {
  const text = onDark ? "text-white/70" : "text-warm-text-tertiary";
  const link = onDark
    ? "text-white underline underline-offset-2 hover:text-white"
    : "text-warm-text-secondary underline underline-offset-2 hover:text-warm-text-primary";

  return (
    <p className={`text-xs leading-relaxed ${text} ${className}`.trim()}>
      By continuing, you agree to the{" "}
      <Link to="/terms" className={link}>
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link to="/privacy" className={link}>
        Privacy Policy
      </Link>
      .
    </p>
  );
}
